export enum BlockExcludedDatesActivityTypes {
  Deadline = 'deadline',
}

export const checkIfExcludedDatesBeBlocked = (activityType?: string) => {
  if (activityType === BlockExcludedDatesActivityTypes.Deadline.toString()) {
    return true;
  }
  return false;
};
